import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const BanIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M0.5 8C0.5 12.1357 3.86426 15.5 8 15.5C12.1357 15.5 15.5 12.1357 15.5 8C15.5 3.86426 12.1357 0.5 8 0.5C3.86426 0.5 0.5 3.86426 0.5 8ZM13.5 8C13.5 9.15564 13.1398 10.2279 12.5283 11.1143L4.8858 3.47168C5.77209 2.86023 6.84436 2.5 8 2.5C11.0322 2.5 13.5 4.96777 13.5 8ZM2.5 8C2.5 6.84436 2.86023 5.77209 3.47174 4.88574L11.1142 12.5283C10.2279 13.1398 9.15564 13.5 8 13.5C4.96777 13.5 2.5 11.0322 2.5 8Z" })));
};

export { BanIcon };
//# sourceMappingURL=BanIcon.esm.js.map
